(function(){
var GRX=document.getElementById('grx');if(!GRX)return;

var FIXED={"Small Rail":39.99};

/* ===================== Shopify glue =====================
   GR_DATA comes from the section (Liquid): the four GrabRail products picked in the theme editor.
   Variants are matched by their option values, so the SKUs and variant order can be anything. */
function norm(s){return String(s||"").toLowerCase().replace(/[″"”'’]|inch|in\b/g,"").replace(/\s+/g," ").trim()}
function vfind(prod,tests){
  if(!prod||!prod.variants)return null;
  return prod.variants.filter(function(v){var o=norm([v.option1,v.option2,v.option3,v.title].join(" | "));
    return tests.every(function(t){return t.test(o)})})[0]||null}
function rxDrive(d){return new RegExp("(^|[^0-9/-])"+d.replace("/","\\/")+"($|[^0-9])")}
var VAR={};   /* sku key -> {id, price, available} */
function applyShop(){
  var D=window.GR_DATA||{},ok=0,miss=[];
  function put(key,v,setPrice){if(v){VAR[key]={id:v.id,price:v.price/100,available:v.available};setPrice(v.price/100);ok++}else miss.push(key)}
  PK.forEach(function(p){
    var sys=p[2]==="metric"?/metric|mm/:/sae|imperial|standard/;
    put(p[0],vfind(D.statics,[rxDrive(p[1]),sys]),function(x){p[5]=x})});
  R.forEach(function(r){
    C.forEach(function(c){var v=vfind(D.rails,[new RegExp("\\b"+r[1]+"\\b"),new RegExp("\\b"+c[0]+"\\b")]);
      if(v){VAR[r[0]+":"+c[0]]={id:v.id,price:v.price/100,available:v.available};r[3]=v.price/100;ok++}else miss.push(r[0]+":"+c[0])})});
  DR.forEach(function(d){put("PACK:"+d,vfind(D.packs,[rxDrive(d)]),function(x){KITPRICE=x})});
  K.forEach(function(k){put("COMBO:"+k[0],vfind(D.combos,[new RegExp("\\b"+norm(k[0]).replace(/ /g,"\\s*")+"\\b")]),function(x){FIXED[k[0]]=x})});
  return {live:ok>0,missing:miss}}

function lineFor(key,q,props){var v=VAR[key];if(!v)throw new Error(key);var o={id:v.id,quantity:q};if(props)o.properties=props;return o}
function cap(s){return s.charAt(0).toUpperCase()+s.slice(1)}
function cartLines(){
  var items=[];
  if(mode==="sets"){
    if(pick<0)return items;
    var k=K[pick],inc={},incPacks=skits.slice(0,k.rails),morePacks=skits.slice(k.rails),props={};
    setSkus().forEach(function(x){(setLines[x.sku]||[]).forEach(function(e){
      var n=e.q-(e.x||0);if(n>0){var lab=(x.kind==="full"?"Full":"Half")+" rail";inc[lab]=inc[lab]||[];inc[lab].push(cap(e.c)+" ×"+n)}
      if(e.x)items.push(lineFor(x.sku+":"+e.c,e.x*QTY))})});
    Object.keys(inc).forEach(function(l){props[l+" colors"]=inc[l].join(", ")});
    if(incPacks.length){var pc=kitCounts(incPacks);props["Twist locks"]=DR.filter(function(d){return pc[d]}).map(function(d){return d+"″ ×"+pc[d]}).join(", ")}
    items.unshift(lineFor("COMBO:"+k[0],QTY,props));
    var mc=kitCounts(morePacks);DR.forEach(function(d){if(mc[d])items.push(lineFor("PACK:"+d,mc[d]*QTY))});
  }else{
    PK.forEach(function(p){if(stat[p[0]]>0)items.push(lineFor(p[0],stat[p[0]]*QTY))});
    R.forEach(function(r){rail[r[0]].forEach(function(e){if(e.q>0)items.push(lineFor(r[0]+":"+e.c,e.q*QTY))})});
    var kc=kitCounts(kits);DR.forEach(function(d){if(kc[d])items.push(lineFor("PACK:"+d,kc[d]*QTY))});
  }
  /* merge duplicate variants without properties */
  var seen={},out=[];items.forEach(function(it){if(it.properties){out.push(it);return}
    if(seen[it.id]){seen[it.id].quantity+=it.quantity}else{seen[it.id]=it;out.push(it)}});
  return out}
function showErr(m){var e=document.getElementById("grerr");if(e)e.textContent=m||""}
function openCartDrawer(){
  var d=document.querySelector(".drawer");
  if(d&&typeof window.renderCart==="function"){
    window.renderCart();document.documentElement.classList.add("cart-opening");document.body.classList.add("cart-opening");
    d.classList.add("is-active");setTimeout(function(){d.classList.add("is-visible")},10)}
  else window.location.href=(window.Shopify&&Shopify.routes?Shopify.routes.root:"/")+"cart"}
function addToCart(){
  var b=document.getElementById("ctab");showErr("");
  if(needPacks()){goPacks();return}
  if(b.classList.contains("busy"))return;
  var items;
  try{items=cartLines()}catch(e){showErr("This option isn't available online yet. Try another, or tell us below.");return}
  if(!items.length){showErr(mode==="sets"?"Pick a combo first.":"Add something to your build first.");return}
  b.classList.add("busy");
  fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:"/")+"cart/add.js",{method:"POST",credentials:"same-origin",
    headers:{"Content-Type":"application/json","X-Requested-With":"XMLHttpRequest"},body:JSON.stringify({items:items})})
  .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j}})})
  .then(function(res){b.classList.remove("busy");
    if(!res.ok){showErr(res.j.description||res.j.message||"Couldn't add to cart.");return}
    openCartDrawer()})
  .catch(function(){b.classList.remove("busy");showErr("Couldn't reach the cart. Check your connection and try again.")})}
function sendFeedback(p){
  var f=new FormData();f.append("form_type","contact");f.append("utf8","✓");
  f.append("contact[email]",p.email||"no-reply@stupidsimple.tools");
  f.append("contact[body]","GrabRail customizer feedback\nType: "+p.type+"\n\n"+p.message+"\n\n"+(p.build||""));
  window.__lastFeedback=p;
  try{fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:"/")+"contact",{method:"POST",body:f,credentials:"same-origin"})}catch(e){}}

var C=[["yellow","#F2C218"],["green","#1F6B34"],["purple","#6A3D9A"],["black","#1a1a1a"]];
var HEX={};C.forEach(function(c){HEX[c[0]]=c[1]});
var MET="#1F3E8C",IMP="#C8202A",DR=["1/4","3/8","1/2"];

/* static packs: id, drive, system, plates covered, plate count, price */
var PK=[
["S14M","1/4","metric",  ["#4–#15"],1,19.99],
["S14I","1/4","imperial",["#1/8–#5/8"],1,19.99],
["S38M","3/8","metric",  ["#6–#16","#17–#24","#25–#27 half"],3,49.99],
["S38I","3/8","imperial",["#1/4–#13/16","#7/8–#1″ half"],2,29.99],
["S12M","1/2","metric",  ["#10–#18","#19–#25","#26–#31","#32–#36","#37–#38 half"],5,89.99],
["S12I","1/2","imperial",["#3/8–#7/8","#15/16–#1-1/4","#1-5/16–#1-1/2"],3,59.99]];

/* modular rails: id, length, slots, price. Drive-agnostic. */
var R=[["FULL","full",12,17.99],["HALF","half",6,11.99]];
/* socket packs (twist locks internally): id, drive, price. 8 per pack. One pack included per rail. */
var TL=[["K14","1/4",4.99],["K38","3/8",4.99],["K12","1/2",4.99]];
var KITPRICE=4.99;

var META={};PK.forEach(function(p){META[p[0]]={kind:"pack",drive:p[1],sys:p[2],plates:p[4],price:p[5]}});
R.forEach(function(r){META[r[0]]={kind:"rail",len:r[1],price:r[3],plates:1}});
function isRail(k){return META[k]&&META[k].kind==="rail"}

/* sets: name, blurb, contents. Kits are included one per rail, split evenly across drives. */
var allPacks=function(n){var o={};PK.forEach(function(p){o[p[0]]=n});return o};
var K=[
["Master","30 static plates, shallow and deep, both systems. Plus 9 modular rails in your color for the rest of the drawer.",
 Object.assign(allPacks(2),{FULL:6,HALF:3})],
["Essential","15 static plates, one pack per drive size, both systems. Plus a full and a half modular rail to try.",
 Object.assign(allPacks(1),{FULL:1,HALF:1})],
["Big Rail","9 modular rails in your color, nothing else. Shallow, deep, impact and bit sockets.",
 {FULL:6,HALF:3}],
["Small Rail","3 full modular rails in your color. Start here and add more later.",
 {FULL:3}]];

var SHOP=applyShop();
PK.forEach(function(p){META[p[0]].price=p[5]});R.forEach(function(r){META[r[0]].price=r[3]});
function money(v){return "$"+v.toFixed(2)}
function alaCarte(m){var t=0;for(var k in m)t+=m[k]*META[k].price;return t}
function plates(m){var n=0;for(var k in m)n+=m[k]*META[k].plates;return n}
function railCount(m){var n=0;for(var k in m)if(isRail(k))n+=m[k];return n}
/* 20% off a la carte, rounded down to .99. Small Rail is fixed at the ad price. Live combo prices come from Shopify. */
function setPrice(k){return FIXED[k[0]]!=null?FIXED[k[0]]:Math.floor(alaCarte(k[2])*0.8)-0.01}
function offPct(k){return Math.round((1-k.price/k.list)*100)}
K.forEach(function(k){k.price=setPrice(k);k.list=alaCarte(k[2]);k.plates=plates(k[2]);k.rails=railCount(k[2]);k.stat=k.plates-k.rails;k.badge=k.stat?[k.stat,"plates"]:[k.rails,"rails"]});
document.getElementById("fromprice").textContent="From "+money(Math.min.apply(null,K.map(function(k){return k.price})));
function kitSplit(n){var o={};DR.forEach(function(d,i){o[d]=Math.floor(n/3)+(i<n%3?1:0)});return o}

var pick=-1,mode="sets",QTY=1;
/* first visit: a random color per rail kind (full and half never match); after that, whatever was last picked */
var DEF={};
function loadColors(){var full=null,half=null;try{full=localStorage.getItem("gr.color.full");half=localStorage.getItem("gr.color.half")}catch(e){}
  var ok=function(v){return v&&C.some(function(c){return c[0]===v})};
  if(!ok(full))full=C[Math.floor(Math.random()*C.length)][0];
  if(!ok(half)||half===full){var rest=C.filter(function(c){return c[0]!==full});half=rest[Math.floor(Math.random()*rest.length)][0]}
  DEF.FULL=full;DEF.HALF=half;saveColor("FULL",full);saveColor("HALF",half)}
function saveColor(sku,v){try{localStorage.setItem("gr.color."+(sku==="FULL"?"full":"half"),v)}catch(e){}}
loadColors();
var oneColor=DEF.FULL,setLines={};
var stat={},rail={},kits=[],gcolor=DEF.FULL;   /* kits: ordered list of drives, one entry per kit added */
PK.forEach(function(p){stat[p[0]]=0});
R.forEach(function(r){rail[r[0]]=[{c:DEF[r[0]]||gcolor,q:0,t:false}]});


function setSkus(){
  if(pick<0)return [];
  var m=K[pick][2];
  return R.filter(function(r){return (m[r[0]]||0)>0})
          .map(function(r){return {sku:r[0],kind:r[1],slots:r[2],total:m[r[0]]}});
}
function seedSetLines(){
  setLines={};
  setSkus().forEach(function(x){setLines[x.sku]=[{c:DEF[x.sku]||oneColor,q:x.total,x:0}]});
}
function setColorCounts(){
  var cnt={};
  setSkus().forEach(function(x){(setLines[x.sku]||[]).forEach(function(e){if(e.q>0)cnt[e.c]=(cnt[e.c]||0)+e.q})});
  return cnt;
}

/* set cards */
var sgw=document.getElementById("setgrid");
K.forEach(function(k,i){
  var mn=k.rails,st=k.plates-mn,parts=[];
  if(st)parts.push(st+' static');
  if(mn)parts.push(mn+' modular, you pick the color');
  var d=document.createElement("div");
  d.className="set";
  d.innerHTML='<div class="hd"><h3>'+k[0]+'</h3><span class="tg"><b>'+k.badge[0]+'</b>'+k.badge[1]+'</span></div><div class="desc">'+k[1]+'</div>'+
    '<div class="pr"><span class="pchip">'+money(k.price)+'</span><span class="was">'+money(k.list)+'</span></div>';
  d.onclick=function(){pick=i;
    [].forEach.call(sgw.children,function(e,j){e.className="set"+(j===pick?" on":"")});
    seedSetLines();seedSetKits();paintColorStep();draw();
    centerBuilder()};
  sgw.appendChild(d);
});




/* ===== Mobile renderers: same data and click hooks, tile layout ===== */
var MOB=window.matchMedia("(max-width:560px)");
if(MOB.addEventListener)MOB.addEventListener("change",function(){paintColorStep();draw()});
function packRange(p){var a=p[3][0].split("–")[0],z=p[3][p[3].length-1].replace(/ half$/,"").split("–");z=z[z.length-1];
  a=a.replace(/#/g,"").replace(/″/g,"");z=z.replace(/#/g,"").replace(/″/g,"").replace(/ in$/,"");
  return p[2]==="metric"?a+"–"+z+" mm":a+"–"+z+"&Prime;"}
function mStp(attrs,q,disabled,of,over){return '<div class="stp msp'+(of!=null?' of':'')+(over?' over':'')+'"><button '+attrs+' data-d="-1"'+(disabled?' disabled':'')+'>&minus;</button><span>'+q+(of!=null?'<i> / '+of+'</i>':'')+'</span><button '+attrs+' data-d="1">+</button></div>'}
function mKits(arr,allow,ks){
  var kc=kitCounts(arr),nk=arr.length,extra=Math.max(0,nk-allow),used=Math.min(nk,allow),left=Math.max(0,allow-nk),pills='';
  if(used)pills+='<span class="g">'+used+' free</span>';
  if(left)pills+='<span class="n0">'+left+' free to pick</span>';
  if(extra)pills+='<span class="o">'+extra+' extra &middot; '+money(extra*KITPRICE)+'</span>';
  var h='<div class="mh"><b>Twist locks</b></div><div class="msub">'+(allow?'1 free pack per rail':'1 free pack with each rail, or '+money(KITPRICE)+' a pack')+'</div>'+(pills?'<div class="ksum">'+pills+'</div>':'')+'<div class="krs">';
  DR.forEach(function(d){var q=kc[d];
    h+='<div class="kr"><span class="ki">'+lockSVG(d,"#2b2a28",30)+'</span><div class="kt"><b>'+d+'&Prime;</b><span>8 pieces</span></div>'+
      '<div class="kpc"><span class="mpr">'+money(KITPRICE)+'</span><div class="stp"><button data-kit="'+d+'" data-ks="'+ks+'" data-d="-1"'+(q?'':' disabled')+'>&minus;</button><span>'+q+'</span><button data-kit="'+d+'" data-ks="'+ks+'" data-d="1">+</button></div></div></div>'});
  return h+'</div>'}
function mStatic(){
  var h='<div class="sub stat"><div class="subhd">Static GrabRail</div><div class="subbd mb">'+
    '<div class="co"><div><b>Every plate comes complete</b> with magnetic base, bumper and 2 grid connectors.</div></div>';
  DR.forEach(function(d){
    h+='<div class="mh"><b>'+d+'&Prime; Drive</b></div><div class="mgrid">';
    PK.filter(function(p){return p[1]===d}).forEach(function(p){var q=stat[p[0]];
      h+='<div class="mtile"><div class="mtr"><span class="mn">'+p[2].charAt(0).toUpperCase()+p[2].slice(1)+'</span><span class="mpr">'+money(p[5])+'</span></div>'+
        '<div class="mic">'+railSVG("static","full",p[2]==="metric"?MET:IMP,"")+'</div><div class="mrng">'+packRange(p)+'</div><div class="msm">'+p[4]+' plate'+(p[4]>1?'s':'')+'</div>'+
        mStp('data-s="'+p[0]+'"',q,q<=0)+'</div>'});
    h+='</div>'});
  return h+'</div></div>'}
function mBuildMod(){
  var h='<div class="sub mod"><div class="subhd">Modular GrabRail</div><div class="subbd mb">'+
    '<div class="co"><div><b>Each modular rail comes with a mag base, bumper and 2 grid connectors.</b></div>'+MLOCKLINE+'</div>';
  R.forEach(function(r){var lines=rail[r[0]];
    h+='<div class="mh"><b>'+(r[1]==="full"?"Full":"Half")+' rail</b></div><div class="msub">'+railSub(r[1])+'</div><div class="mgrid">';
    lines.forEach(function(e,ix){
      h+='<div class="mtile"><div class="mtr"><span class="mn">'+e.c.charAt(0).toUpperCase()+e.c.slice(1)+'</span><span class="mpr">'+money(r[3])+'</span></div>'+
        '<div class="mic">'+railSVG("rail",r[1],HEX[e.c],"")+'</div>'+swatches("rail",r[0],ix,e.c)+
        mStp('data-r="'+r[0]+'" data-ci="'+ix+'"',e.q,e.q<=0)+'</div>'});
    if(lines.length<C.length)h+='<div class="mdash ghost" data-addc="'+r[0]+'"><b>+</b>Add a color</div>';
    h+='</div>'});
  h+=mKits(kits,railsInBuild(),"b");
  return h+'</div></div>'}
function mSetMod(skus,k){
  var parts=skus.map(function(x){return x.total+' '+x.kind});
  var h='<div class="sub mod"><div class="subhd">Modular GrabRail</div><div class="subbd mb">'+
    '<div class="co"><div><b>'+k[0]+' set includes '+parts.join(' and ')+' modular rails.</b> Add more for '+money(R[0][3])+' full, '+money(R[1][3])+' half.</div><div>'+PARTSLINE+'</div>'+MLOCKLINE+'</div>';
  skus.forEach(function(x){
    var lines=setLines[x.sku]||[],pr=R.filter(function(r){return r[0]===x.sku})[0][3],tot=0,xt=0;
    lines.forEach(function(e){tot+=e.q;xt+=e.x||0});var left=x.total-(tot-xt),pills='';
    if(left>0)pills+='<span class="n0">'+left+' still to assign</span>';
    if(xt)pills+='<span class="o">+'+xt+' extra &middot; '+money(xt*pr)+'</span>';
    h+='<div class="mh"><b>'+(x.kind==="full"?"Full":"Half")+' rail</b></div><div class="msub">'+railSub(x.kind)+' &middot; '+x.total+' included, extras '+money(pr)+'</div>'+
      (pills?'<div class="ksum">'+pills+'</div>':'')+'<div class="mgrid">';
    lines.forEach(function(e,ix){
      h+='<div class="mtile"><div class="mtr"><span class="mn">'+e.c.charAt(0).toUpperCase()+e.c.slice(1)+'</span></div>'+
        '<div class="mic">'+railSVG("rail",x.kind,HEX[e.c],"")+'</div>'+swatches("set",x.sku,ix,e.c)+
        mStp('data-sq="'+x.sku+'" data-si="'+ix+'"',e.q,e.q<=0,x.total,(e.x||0)>0)+'</div>'});
    if(lines.length<C.length&&x.total>1)h+='<div class="mdash ghost" data-addsc="'+x.sku+'"><b>+</b>Add a color</div>';
    h+='</div>'});
  h+=mKits(skits,setKitAllow(),"s");
  return h+'</div></div>'}

function paintColorStep(){
  var wrap=document.getElementById("cstep");
  if(pick<0){wrap.innerHTML="";return}
  var skus=setSkus();
  if(!skus.length){wrap.innerHTML='<div class="cstep none">The '+K[pick][0]+
    ' set is static packs only, so there is no color to choose. Modular rails come in the other sets, '+
    'or add them in the builder.</div>';return}
  var k=K[pick];
  if(MOB.matches){wrap.innerHTML=mSetMod(skus,k);return}
  var parts=skus.map(function(x){return x.total+' '+x.kind});
  var h='<div class="sub mod"><div class="subhd">Modular GrabRail</div><div class="subbd">'+
    '<div class="co"><div><b>'+k[0]+' set includes '+parts.join(' and ')+' modular rails.</b> Add more for '+money(R[0][3])+' full, '+money(R[1][3])+' half.</div><div>'+PARTSLINE+'</div>'+LOCKLINE+'</div>';
  skus.forEach(function(x){
    var lines=setLines[x.sku]||[],pr=R.filter(function(r){return r[0]===x.sku})[0][3];
    var tot=0,xt=0;lines.forEach(function(e){tot+=e.q;xt+=e.x||0});
    var left=x.total-(tot-xt);
    var tip=x.total+' '+x.kind+' rail'+(x.total>1?'s':'')+' come'+(x.total>1?'':'s')+' with this set. Split '+(x.total>1?'them':'it')+' across colors any way you like. Past '+x.total+', each extra rail is '+money(pr)+' and comes with its own free 8-piece pack.';
    h+='<div class="rg">';
    var tail='';
    if(xt)tail+='<div class="rnote">+'+xt+' extra '+x.kind+' rail'+(xt>1?'s':'')+'</div>';
    if(left>0)tail+='<div class="rnote">'+left+' '+x.kind+' rail'+(left>1?'s':'')+' still to assign. Pick a color.</div>';
    if(lines.length<C.length&&x.total>1)
      tail+='<div class="ghost" data-addsc="'+x.sku+'"><b>+</b>Add more colors</div>';
    lines.forEach(function(e,ix){
      var last=ix===lines.length-1;
      h+='<div class="mrow'+(last&&tail?' tall':'')+'"><span class="railbtn static">'+railSVG("rail",x.kind,HEX[e.c],"glbig")+'</span>'+
        '<div class="t">'+railName(x.kind,e.c)+'<s>'+railSub(x.kind)+'</s>'+(last?tail:'')+'</div>'+
        swatches("set",x.sku,ix,e.c)+
        '<div class="stp of'+((e.x||0)>0?' over':'')+'" data-tip="'+tip+'"><button data-sq="'+x.sku+'" data-si="'+ix+'" data-d="-1"'+
        (e.q<=0?' disabled':'')+'>&minus;</button><span>'+e.q+'<i> / '+x.total+'</i></span>'+
        '<button data-sq="'+x.sku+'" data-si="'+ix+'" data-d="1">+</button></div></div>';
    });
    h+='</div>';
  });
  h+=kitSection(skits,setKitAllow(),"s",'');
  h+='</div></div>';
  wrap.innerHTML=h;
}

function centerBuilder(){
  var el=document.querySelector("#cstep .sub.mod")||document.getElementById("cstep");if(!el)return;
  var r=el.getBoundingClientRect(),vh=window.innerHeight,off=Math.max(72,(vh-r.height)/2);
  window.scrollTo({top:window.scrollY+r.top-off,behavior:"smooth"})}
document.getElementById("openbuild").onclick=function(){
  setQty(1);mode="custom";GRX.classList.add("custom");setReview(false);draw();window.scrollTo(0,0)};

function railSVG(type,len,color,cls){
  var w=(len==="full")?100:46,h=26,body;
  if(type==="static"){
    var n=(len==="full")?7:3,m=8,span=w-2*m,gap=span/n,c="";
    for(var i=0;i<n;i++)c+='<circle cx="'+(m+gap*i+gap/2).toFixed(1)+'" cy="13" r="4.6" fill="#fff"/>';
    body='<rect width="'+w+'" height="'+h+'" rx="6" fill="'+color+'"/>'+c;
  }else{
    body='<rect width="'+w+'" height="'+h+'" rx="6" fill="'+color+'"/>'+
      '<rect x="4.5" y="9" width="'+(w-9)+'" height="8" rx="1.5" fill="#fff" stroke="rgba(0,0,0,.45)" stroke-width="1"/>';
  }
  return '<svg class="'+cls+'" viewBox="0 0 '+w+' '+h+'" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" style="pointer-events:none">'+body+'</svg>';
}
/* twist lock side silhouette. Base 18x3; alignment step 12.7 wide on the base; twist by drive (65/75/100% tall),
   drawn as a path so all three share the same top-corner radius; white ball at 45% of the twist. Content is
   vertically centred inside the 17-unit box so the three sizes sit at the same visual centre. */
function lockSVG(d,color,h){
  var sw={"1/4":6.4,"3/8":9.5,"1/2":12.7}[d],th={"1/4":8.06,"3/8":9.3,"1/2":12.4}[d];
  var STEP_W=12.7,STEP_H=1.7,RX=1.6,stepTop=13-STEP_H,top=stepTop-th,yb=13.4;
  var x0=11-sw/2,x1=11+sw/2,f=function(v){return v.toFixed(2)};
  var twist='M'+f(x0)+','+f(yb)+' V'+f(top+RX)+' Q'+f(x0)+','+f(top)+' '+f(x0+RX)+','+f(top)+' H'+f(x1-RX)+
    ' Q'+f(x1)+','+f(top)+' '+f(x1)+','+f(top+RX)+' V'+f(yb)+' Z';
  var ch=16-top,y0=top-(17-ch)/2;
  return '<svg viewBox="0 '+f(y0)+' 22 17" style="height:'+(h||17)+'px;width:'+((h||17)*22/17).toFixed(1)+'px;display:block;flex:0 0 auto" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">'+
    '<path d="'+twist+'" fill="'+color+'"/>'+
    '<rect x="'+f(11-STEP_W/2)+'" y="'+f(stepTop)+'" width="'+STEP_W+'" height="'+f(STEP_H+1)+'" fill="'+color+'"/>'+
    '<rect x="2" y="13" width="18" height="3" rx=".6" fill="'+color+'"/>'+
    '<circle cx="11" cy="'+f(top+th*0.45)+'" r="'+f(Math.min(1.5,sw*0.14))+'" fill="#fff"/></svg>';
}
function swatches(kind,k,ix,cur){
  return '<div class="sw row" role="radiogroup">'+C.map(function(c){
    var attr=kind==="set"?'data-scc="'+c[0]+'" data-sck="'+k+'" data-sci="'+ix+'"'
                         :'data-pc="'+c[0]+'" data-pk="'+k+'" data-pi="'+ix+'"';
    return '<i style="background:'+c[1]+'" title="'+c[0]+'" class="'+(c[0]===cur?"on":"")+'" '+attr+'></i>'}).join("")+'</div>';
}

/* builder totals */
function railsInBuild(){var n=0;R.forEach(function(r){rail[r[0]].forEach(function(e){n+=e.q})});return n}
function kitCounts(arr){arr=arr||kits;var o={};DR.forEach(function(d){o[d]=0});arr.forEach(function(d){o[d]++});return o}
/* the last (kits - allowance) kits added are the extras: "last in pays" */
function extrasByDrive(arr,allow){
  arr=arr||kits;if(allow==null)allow=railsInBuild();
  var extra=Math.max(0,arr.length-allow),o={};DR.forEach(function(d){o[d]=0});
  for(var i=arr.length-extra;i<arr.length;i++)o[arr[i]]++;
  return o;
}
var skits=[];   /* kits chosen for the picked set, ordered; the first k.rails are free */
function seedSetKits(){skits=[];if(pick<0)return;var sp=kitSplit(K[pick].rails);DR.forEach(function(d){for(var i=0;i<sp[d];i++)skits.push(d)})}
function setExtras(){return pick<0?0:Math.max(0,skits.length-setKitAllow())}
/* shared: meter + tiles. ks = "b" (builder, kits array) or "s" (set, skits array) */
function kitSection(arr,allow,ks,note){
  var kc=kitCounts(arr),ex=extrasByDrive(arr,allow),nk=arr.length,extra=Math.max(0,nk-allow);
  var pips="";for(var i=0;i<allow;i++)pips+='<i class="'+(i<nk?"on":"")+'"></i>';
  for(var j=0;j<extra;j++)pips+='<i class="x"></i>';
  var h='<div class="meter"><div class="ml"><b>Twist locks</b></div>'+
    '<span class="pips">'+pips+'</span><span class="mt">'+
    (allow?((allow-nk>0)?(allow-nk)+' free pack'+(allow-nk===1?'':'s')+' left':allow+' of '+allow+' free used')+(extra?', <b>'+extra+' extra</b>':''):(nk?nk+' pack'+(nk===1?'':'s')+' at '+money(KITPRICE)+' each':'1 free pack per rail, or '+money(KITPRICE)+' each'))+'</span></div>';
  h+='<div class="tiles">'+DR.map(function(d){
    var q=kc[d],x=ex[d],fr=q-x,cls="pr"+(q===0?" off":(x===0?" strike":""));
    return '<div class="tile"><div class="ico">'+lockSVG(d,"#2b2a28",{"1/4":27,"3/8":25.5,"1/2":23}[d])+'</div>'+
      '<div class="tl"><div><div class="d">'+d+'&Prime;</div><div class="k">8 pieces</div></div></div>'+
      '<div class="stp"><button data-kit="'+d+'" data-ks="'+ks+'" data-d="-1"'+(q?'':' disabled')+'>&minus;</button><span>'+q+'</span>'+
      '<button data-kit="'+d+'" data-ks="'+ks+'" data-d="1">+</button></div></div>'}).join("")+'</div>';
  if(allow&&nk<allow)h+='<div class="kitnote"><b>'+(allow-nk)+' free pack'+(allow-nk===1?'':'s')+' still to choose.</b> Pick the size'+(allow-nk===1?'':'s')+' above.</div>';
  return h;
}
function railName(kind,c){return (kind==="full"?"Full":"Half")+' rail <span class="c">&middot; '+c+'</span>'}
function railSub(kind){return 'Holds up to '+(kind==="full"?12:6)+' sockets'}
function setExtraRails(){var n=0;if(pick<0)return 0;setSkus().forEach(function(x){(setLines[x.sku]||[]).forEach(function(e){n+=e.x||0})});return n}
function setExtraRailCost(){var v=0;if(pick<0)return 0;setSkus().forEach(function(x){var pr=R.filter(function(r){return r[0]===x.sku})[0][3];(setLines[x.sku]||[]).forEach(function(e){v+=(e.x||0)*pr})});return v}
function setKitAllow(){return pick<0?0:K[pick].rails+setExtraRails()}
var CHV='<svg class="chv" viewBox="0 0 12 8" width="12" height="8" aria-hidden="true"><path d="M1 1.5 6 6.5 11 1.5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
var LOCKLINE='<div><b>Pick twist locks below.</b> Any size fits any rail. One free 8-piece pack per rail, extras '+money(KITPRICE)+'.</div>';
var MLOCKLINE='<div><b>Pick twist locks below.</b> Any size fits any rail.</div>';
var PARTSLINE='<b>Each rail comes with a mag base, bumper and 2 grid connectors.</b>';

/* R1 review rows */
var TAGX='<span class="tg2 x">Extra</span>',TAGI='<span class="tg2 i">Included</span>';
function MSH(l,r){return '<div class="msh"><span>'+l+'</span><span>'+r+'</span></div>'}
function MR(icon,name,q,price,was,tag,sub){return '<div class="mr"><span class="nm"><span class="ic">'+icon+'</span><span>'+name+' <span class="qx">&times;'+q+'</span></span>'+(tag||'')+'</span><span class="pz">'+(was?'<s>'+money(was)+'</s>':'')+(price>0?money(price):'<span class="fr">Free</span>')+'</span>'+(sub||'')+'</div>'}
/* the individual plates inside a static pack */
function plateList(p){var u=p[2]==="metric"?" mm":"&Prime;";
  return '<div class="mpl">'+p[3].map(function(r){var half=/ half$/.test(r);r=r.replace(/ half$/,"").replace(/#/g,"").replace(/″/g,"");
    return '<span>'+r+u+(half?' <em>half plate</em>':'')+'</span>'}).join("")+'</div>'}
function icPlate(sys){return railSVG("static","full",sys==="metric"?MET:IMP,"mi")}
function icRail(kind,c){return railSVG("rail",kind,HEX[c],"mi")}
function icLock(d){return lockSVG(d,"#2b2a28",16)}
function packName(p){return p[1]+'&Prime; '+p[2].charAt(0).toUpperCase()+p[2].slice(1)+' pack'}
function railLabel(kind,c){return (kind==="full"?"Full":"Half")+' rail <span class="c">&middot; '+c+'</span>'}
/* split a combo price across its lines in proportion to list price, to the cent, so the lines add up to the combo */
function alloc(lists,target){var L=0,T=Math.round(target*100),c=lists.map(function(v){var x=Math.round(v*100);L+=x;return x});
  var raw=c.map(function(x){return x*T/L}),fl=raw.map(Math.floor),rem=T-fl.reduce(function(a,b){return a+b},0);
  raw.map(function(r,i){return [r-fl[i],i]}).sort(function(a,b){return b[0]-a[0]}).slice(0,rem).forEach(function(e){fl[e[1]]++});
  return fl.map(function(x){return x/100})}

function draw(){
  var secs=document.getElementById("secs");secs.innerHTML="";
  var ssec=document.createElement("div");ssec.className="dsec";ssec.id="sec-static";
  var sh='<div class="sub stat"><div class="subhd">Static GrabRail</div><div class="subbd">'+
    '<div class="co"><div><b>Every plate comes complete</b> with magnetic base, bumper and 2 grid connectors.</div></div>';
  DR.forEach(function(d){
    var packs=PK.filter(function(p){return p[1]===d});
    var h='<div class="drvhd">'+d+'&Prime; Drive</div>';
    packs.forEach(function(p){
      var col=p[2]==="metric"?MET:IMP,pl=p[4]+' plate'+(p[4]>1?'s':'');
      var sizes=p[3].map(function(s){return '<span class="chip">'+s.replace(/ half$/,"").replace(/–#/,"–")+'</span>'}).join("");
      h+='<div class="mrow"><span class="railbtn static">'+railSVG("static","full",col,"glbig")+'</span>'+
        '<div class="t">'+p[2].charAt(0).toUpperCase()+p[2].slice(1)+' pack <span class="c">&middot; '+pl+'</span>'+
        '<div class="chips">'+sizes+'</div></div>'+
        '<span class="pr2">'+money(p[5])+'</span>'+
        '<div class="stp"><button data-s="'+p[0]+'" data-d="-1">&minus;</button><span>'+stat[p[0]]+'</span>'+
        '<button data-s="'+p[0]+'" data-d="1">+</button></div></div>';
    });
    sh+=h;
  });
  sh+='</div></div>';
  ssec.innerHTML=sh;secs.appendChild(ssec);

  /* one modular section, drive-agnostic */
  var msec=document.createElement("div");msec.className="dsec";msec.id="sec-modular";
  var allow=railsInBuild();
  var h='<div class="sub mod"><div class="subhd">Modular GrabRail</div><div class="subbd">'+
    '<div class="co"><div><b>Each modular rail comes with a mag base, bumper and 2 grid connectors.</b></div>'+LOCKLINE+'</div>';
  R.forEach(function(r){
    var lines=rail[r[0]];
    h+='<div class="rg">';
    var tail=(lines.length<C.length)?'<div class="ghost" data-addc="'+r[0]+'"><b>+</b>Add more colors</div>':'';
    lines.forEach(function(e,ix){
      var last=ix===lines.length-1;
      h+='<div class="mrow'+(ix?" extra":"")+(last&&tail?' tall':'')+'">'+
        '<span class="railbtn static">'+railSVG("rail",r[1],HEX[e.c],"glbig")+'</span>'+
        '<div class="t">'+railName(r[1],e.c)+'<s><span class="pin">'+money(r[3])+' &middot; </span>'+railSub(r[1])+'</s>'+(last?tail:'')+'</div>'+
        swatches("rail",r[0],ix,e.c)+
        '<span class="pr2">'+money(r[3])+'</span>'+
        '<div class="stp"><button data-r="'+r[0]+'" data-ci="'+ix+'" data-d="-1">&minus;</button><span>'+e.q+'</span>'+
        '<button data-r="'+r[0]+'" data-ci="'+ix+'" data-d="1">+</button></div></div>';
    });
    h+='</div>';
  });
  h+=kitSection(kits,allow,"b",'One free pack per rail. Extras '+money(KITPRICE)+' a pack');
  h+='</div></div>';
  msec.innerHTML=h;secs.appendChild(msec);
  if(MOB.matches){ssec.innerHTML=mStatic();msec.innerHTML=mBuildMod()}

  /* cart */
  var mh="",n=0;
  function ML(dot,name,q,price,was,cls){return '<div'+(cls?' class="'+cls+'"':'')+'><span class="nm">'+(dot?'<span class="dot" style="background:'+dot+'"></span>':'')+name+'</span><span class="q">&times;'+q+'</span><span class="pz">'+(was?'<s>'+money(was)+'</s>':'')+(price>0?money(price):'Free')+'</span></div>'}
  if(mode==="sets"&&pick<0){
    document.getElementById("cnt").innerHTML='<span>Pick a combo, or build your own</span>';document.getElementById("cnt").className="sumline idle";document.getElementById("sumwrap").className="sumwrap idle";
    document.getElementById("prow").innerHTML='<span id="fromprice">From '+money(Math.min.apply(null,K.map(function(k){return k.price})))+'</span>';
    document.getElementById("ctab").textContent="Add to cart";
    document.getElementById("mani").innerHTML="";shipBar(0);return;
  }
  if(mode==="sets"){
    var k=K[pick],m=k[2],cnt={},sx=setExtras(),xr=setExtraRails(),xrc=setExtraRailCost(),kc2=kitCounts(skits),ex2=extrasByDrive(skits,setKitAllow()),tot=k.price+sx*KITPRICE+xrc;
    /* included lines share the combo price; extras are full price */
    var inc=[],ni=0;
    PK.forEach(function(p){if(m[p[0]])inc.push({t:"p",p:p,q:m[p[0]],list:m[p[0]]*p[5]})});
    setSkus().forEach(function(x){var pr=R.filter(function(r){return r[0]===x.sku})[0][3];(setLines[x.sku]||[]).forEach(function(e){
      var n=e.q-(e.x||0);if(n>0)inc.push({t:"r",kind:x.kind,c:e.c,q:n,list:n*pr});
      if(e.x)inc.push({t:"rx",kind:x.kind,c:e.c,q:e.x,pr:pr})})});
    var paid=inc.filter(function(r){return r.t!=="rx"}),sh=alloc(paid.map(function(r){return r.list}),k.price);
    paid.forEach(function(r,i){r.sh=sh[i]});
    var stl=inc.filter(function(r){return r.t==="p"}),rl=inc.filter(function(r){return r.t!=="p"});
    if(stl.length){mh+=MSH('Static plates',(k.plates-k.rails)+' plates');
      stl.forEach(function(r){mh+=MR(icPlate(r.p[2]),packName(r.p),r.q,r.sh,r.list,'',plateList(r.p));ni++})}
    if(rl.length){mh+=MSH('Modular rails','');
      rl.forEach(function(r){mh+=r.t==="rx"?MR(icRail(r.kind,r.c),railLabel(r.kind,r.c),r.q,r.q*r.pr,0,TAGX):MR(icRail(r.kind,r.c),railLabel(r.kind,r.c),r.q,r.sh,r.list);ni++})}
    if(skits.length){mh+=MSH('Twist locks','');
      DR.forEach(function(d){var fr=kc2[d]-ex2[d];
        if(fr){mh+=MR(icLock(d),d+'&Prime; twist locks <span class="pcs">(8 pcs)</span>',fr,0,fr*KITPRICE,TAGI);ni++}
        if(ex2[d]){mh+=MR(icLock(d),d+'&Prime; twist locks <span class="pcs">(8 pcs)</span>',ex2[d],ex2[d]*KITPRICE,0,TAGX);ni++}})}
    mh+='<div class="mtot"><span>Total'+(QTY>1?' &middot; '+QTY+' sets':'')+'</span><span>'+money(tot*QTY)+'</span></div>';
    document.getElementById("cnt").innerHTML='<span><b>'+k[0]+' set</b> &middot; '+
      (k.stat?k.stat+' plates'+(k.rails?' &middot; '+k.rails+' rails':''):k.rails+' rails')+(xr?' &middot; '+xr+' extra rail'+(xr>1?'s':''):'')+(sx?' &middot; '+sx+' extra pack'+(sx>1?'s':''):'')+'</span><span class="ch">Review '+ni+' items'+CHV+'</span>';
    document.getElementById("cnt").className="sumline";document.getElementById("sumwrap").classList.remove("idle");
    document.getElementById("ctab").innerHTML='Add To Cart<span class="sep">&middot;</span>'+money(tot*QTY);
    document.getElementById("prow").innerHTML='<span>'+money(tot)+'</span><s>'+money(k.list+sx*KITPRICE+xrc)+'</s><span class="offpill">'+offPct(k)+'% off</span>';
  }else{
    var sc=0,mc=0,sub=0;
    var sh1='',sh2='',sh3='',ni=0;
    PK.forEach(function(p){var q=stat[p[0]];if(q>0){sc+=q*p[4];sub+=q*p[5];
      sh1+=MR(icPlate(p[2]),packName(p),q,q*p[5],0,'',plateList(p));ni++}});
    R.forEach(function(r){rail[r[0]].forEach(function(e){if(e.q>0){mc+=e.q;sub+=e.q*r[3];
      sh2+=MR(icRail(r[1],e.c),railLabel(r[1],e.c),e.q,e.q*r[3],0);ni++}})});
    var kc=kitCounts(kits),ex=extrasByDrive(kits,railsInBuild());
    var nr=railsInBuild(),xk=0;
    DR.forEach(function(d){var q=kc[d],x=ex[d],inc=q-x;xk+=x;
      if(inc){sh3+=MR(icLock(d),d+'&Prime; twist locks <span class="pcs">(8 pcs)</span>',inc,0,inc*KITPRICE,TAGI);ni++}
      if(x){sub+=x*KITPRICE;sh3+=MR(icLock(d),d+'&Prime; twist locks <span class="pcs">(8 pcs)</span>',x,x*KITPRICE,0,nr?TAGX:'');ni++}});
    if(sh1)mh+=MSH('Static plates',sc+' plate'+(sc>1?'s':''))+sh1;
    if(sh2)mh+=MSH('Modular rails','')+sh2;
    if(sh3)mh+=MSH('Twist locks','')+sh3;
    if(mh)mh+='<div class="mtot"><span>Total'+(QTY>1?' &middot; '+QTY+' sets':'')+'</span><span>'+money(sub*QTY)+'</span></div>';
    n=sc+mc;var has=n>0||kits.length>0;
    var best=-1,gap=1e9,nw=document.getElementById("nudgewrap");nw.innerHTML="";
    K.forEach(function(k,i){if(k.plates>=n&&k.plates-n<gap){gap=k.plates-n;best=i}});
    if(best>=0&&n>0){
      var setP=K[best].price,diff=sub-setP;
      nw.innerHTML='<div class="callout"><h4>'+(gap===0?"That's the "+K[best][0]+" set":
        "You're "+gap+" plate"+(gap===1?"":"s")+" from the "+K[best][0]+" set")+'</h4>'+
        '<p>'+(diff>0
          ? "Your build is "+money(sub)+". The "+K[best][0]+" set is "+money(setP)+
            " and includes "+(gap?gap+" more plate"+(gap===1?"":"s"):"the same plates")+
            ", "+money(diff)+" less than what you have selected."
          : "Your build is "+money(sub)+". The "+K[best][0]+" set is "+money(setP)+
            " and adds "+gap+" more plate"+(gap===1?"":"s")+" for "+money(-diff)+".")+'</p>'+
        '<button data-jump="'+best+'">'+(gap===0?"Switch to the set":"Show me the set")+'</button></div>';
    }
    var lab=n?'<b>'+n+' plate'+(n>1?'s':'')+'</b> &middot; '+sc+' static &middot; '+mc+' modular'+(xk&&nr?' &middot; '+xk+' extra pack'+(xk>1?'s':''):''):
      (kits.length?'<b>'+kits.length+' twist lock pack'+(kits.length>1?'s':'')+'</b>':'Nothing added yet');
    document.getElementById("cnt").innerHTML='<span>'+lab+'</span>'+(has?'<span class="ch">Review '+ni+' item'+(ni>1?'s':'')+CHV+'</span>':'');
    document.getElementById("cnt").className=has?"sumline":"sumline idle";document.getElementById("sumwrap").className=has?"sumwrap":"sumwrap idle";
    if(!has)setReview(false);
    document.getElementById("ctab").innerHTML=has?'Add To Cart<span class="sep">&middot;</span>'+money(sub*QTY):'Add To Cart';
    document.getElementById("prow2").innerHTML=has?'<span>'+money(sub)+'</span>':'<span>From '+money(R[1][3])+'</span>';
  }
  document.getElementById("mani").innerHTML=mh;
  shipBar(mode==="sets"?(pick<0?0:(K[pick].price+setExtras()*KITPRICE+setExtraRailCost())*QTY):sub*QTY);
}
/* free shipping progress under Add To Cart */
var FREESHIP=(window.GR_DATA&&GR_DATA.freeShip)||250;
function shipBar(v){var w=document.getElementById("ship");
  if(!(v>0)){w.hidden=true;return}w.hidden=false;
  var gap=Math.round((FREESHIP-v)*100)/100,t;
  if(gap<=0)t='<b>Free shipping.</b> Your order is over $'+FREESHIP+'.';
  else t='Add <b>'+money(gap)+'</b> for free shipping.'+(gap<=R[1][3]?' One more half rail gets you there.':gap<=R[0][3]?' One more full rail gets you there.':'');
  document.getElementById("shipt").innerHTML=t;w.classList.toggle("done",gap<=0);
  document.getElementById("shipfill").style.width=Math.min(100,v/FREESHIP*100)+'%'}

function setReview(o){document.getElementById("mani").classList.toggle("open",o);document.getElementById("cnt").classList.toggle("open",o);document.getElementById("sumwrap").classList.toggle("open",o)}
document.getElementById("cnt").onclick=function(){if(this.classList.contains("idle"))return;setReview(!document.getElementById("mani").classList.contains("open"))};

function onPageClick(ev){
  var t=ev.target,d;
  var g=t.closest?t.closest(".ghost"):null;if(g)t=g;
  if(d=t.dataset.addsc){
    var ln=setLines[d],used=ln.map(function(e){return e.c});
    var big=0;ln.forEach(function(e,i){if(e.q>ln[big].q)big=i});
    var nx=C.filter(function(c){return used.indexOf(c[0])<0})[0];
    if(ln[big].q>=2&&!(ln[big].x)){ln[big].q-=1;ln.push({c:nx?nx[0]:oneColor,q:1,x:0})}
    else ln.push({c:nx?nx[0]:oneColor,q:0,x:0});
    paintColorStep();draw();return}
  if(t.dataset.scc){
    var sl=setLines[t.dataset.sck],si=+t.dataset.sci,sc=t.dataset.scc,dup=-1;
    sl.forEach(function(o,j){if(j!==si&&o.c===sc)dup=j});
    if(dup>=0){                 /* that color already has a row: fold this row into it */
      sl[dup].q+=sl[si].q;sl[dup].x=(sl[dup].x||0)+(sl[si].x||0);sl.splice(si,1)}
    else{sl[si].c=sc;if(si===0)saveColor(t.dataset.sck,sc)}
    paintColorStep();draw();return}
  if(t.dataset.back){mode="sets";GRX.classList.remove("custom");setReview(false);
    paintColorStep();draw();window.scrollTo({top:0,behavior:"smooth"});return}
  if(d=t.dataset.jump){pick=+d;mode="sets";GRX.classList.remove("custom");seedSetLines();seedSetKits();
    [].forEach.call(sgw.children,function(e,j){e.className="set"+(j===pick?" on":"")});
    paintColorStep();draw();window.scrollTo({top:0,behavior:"smooth"});return}
  if(d=t.dataset.addc){
    var ln3=rail[d],used3=ln3.map(function(e){return e.c});
    var next=C.filter(function(c){return used3.indexOf(c[0])<0})[0];
    ln3.push({c:next?next[0]:gcolor,q:1,t:true});draw();return}
  if(t.dataset.pc){
    var rl=rail[t.dataset.pk],ri=+t.dataset.pi,pc=t.dataset.pc,dupR=-1;
    rl.forEach(function(o,j){if(j!==ri&&o.c===pc)dupR=j});
    if(dupR>=0){rl[dupR].q+=rl[ri].q;rl.splice(ri,1)}  /* same color already listed: merge the quantities */
    else{var e=rl[ri];e.c=pc;e.t=true;if(ri===0)saveColor(t.dataset.pk,pc)}
    draw();return}
  var b=t.closest?t.closest("button"):null;
  if(!b)return;
  if(b.dataset.sq){
    var ln2=setLines[b.dataset.sq],ix2=+b.dataset.si,dd=+b.dataset.d;
    var sk=setSkus().filter(function(x){return x.sku===b.dataset.sq})[0];
    var T=0,X=0;ln2.forEach(function(e){T+=e.q;X+=e.x||0});
    if(dd>0){
      ln2[ix2].q+=1;
      if(T-X>=sk.total)ln2[ix2].x=(ln2[ix2].x||0)+1;   /* past the included count: this one is paid */
    }else{
      if(ln2[ix2].q<=0)return;
      ln2[ix2].q-=1;
      if((ln2[ix2].x||0)>0)ln2[ix2].x-=1;              /* remove a paid one first */
      if(ln2[ix2].q===0&&ix2>0)ln2.splice(ix2,1);
    }
    paintColorStep();draw();return}
  if(b.dataset.s){stat[b.dataset.s]=Math.max(0,stat[b.dataset.s]+ +b.dataset.d);draw();return}
  if(b.dataset.kit){
    var kd=b.dataset.kit,arrk=b.dataset.ks==="s"?skits:kits;
    if(+b.dataset.d>0)arrk.push(kd);
    else{var li=arrk.lastIndexOf(kd);if(li>=0)arrk.splice(li,1)}
    if(b.dataset.ks==="s")paintColorStep();
    draw();return}
  if(b.dataset.r){
    var lns=rail[b.dataset.r],i2=+b.dataset.ci;
    lns[i2].q=Math.max(0,lns[i2].q+ +b.dataset.d);
    if(lns[i2].q===0&&i2>0)lns.splice(i2,1);
    draw()}
}
/* keep the page still while steppers, colors and kits re-render: pin the tapped control where it was */
function ctlKey(el){if(!el||!el.attributes)return null;var a=[].filter.call(el.attributes,function(x){return x.name.indexOf("data-")===0}).map(function(x){return "["+x.name+"=\""+x.value+"\"]"}).join("");return a?el.tagName.toLowerCase()+a:null}
document.addEventListener("click",function(ev){
  var t=ev.target;
  if(!GRX.contains(t))return;
  if(!t.closest||t.closest("[data-back],[data-jump]")){onPageClick(ev);return}
  var el=t.closest("[data-s],[data-r],[data-kit],[data-sq],[data-pc],[data-scc],[data-addc],[data-addsc]");
  if(!el){onPageClick(ev);return}
  var add=el.hasAttribute("data-addc")||el.hasAttribute("data-addsc"),sy=window.scrollY,k=ctlKey(el),y0=el.getBoundingClientRect().top;
  onPageClick(ev);
  if(document.activeElement&&document.activeElement!==document.body&&!GRX.contains(document.activeElement))document.body.focus();
  function pin(){var n=!add&&k&&document.querySelector(k);
    if(n){var d=n.getBoundingClientRect().top-y0;if(Math.abs(d)>0.5)window.scrollTo({top:window.scrollY+d,behavior:"instant"})}
    else if(Math.abs(window.scrollY-sy)>0.5)window.scrollTo({top:sy,behavior:"instant"})}
  pin();requestAnimationFrame(function(){pin();setTimeout(pin,60)});
});
/* tapping a stepper should not move focus (Safari scrolls to a focused button that gets redrawn) */
document.addEventListener("mousedown",function(e){if(GRX.contains(e.target)&&e.target.closest&&e.target.closest(".stp button,.sw i,[data-addc],[data-addsc]"))e.preventDefault()});


/* ===== Feedback: capture the build, open/close, send =====
   Prototype: "Send" just shows the thank-you. On Shopify this posts to the store's contact form
   (contact[email], contact[body]) so it lands in the support inbox with the build attached. */
function buildSnapshot(){
  var lines=[],head=document.getElementById("cnt").textContent.replace(/Review.*$/,"").trim();
  lines.push((mode==="sets"?"Combo":"Builder")+": "+(head||"nothing added"));
  [].forEach.call(document.querySelectorAll("#mani .mr"),function(r){var n=r.querySelector(".nm").textContent.replace(/\s+/g," ").trim(),pzEl=r.querySelector(".pz").cloneNode(true);[].forEach.call(pzEl.querySelectorAll("s"),function(x){x.remove()});var pz=pzEl.textContent.trim();lines.push("- "+n+"  "+pz)});
  lines.push("Cart button: "+document.getElementById("ctab").textContent.replace(/\s+/g," ").trim()+(QTY>1?" (qty "+QTY+")":""));
  lines.push("Screen: "+window.innerWidth+"x"+window.innerHeight+" | "+'theme '+((window.Shopify&&Shopify.theme&&Shopify.theme.id)||''));
  return lines.join("\n")}
function fbOpen(){var m=document.getElementById("fbm");document.getElementById("fbform").hidden=false;document.getElementById("fbdone").hidden=true;
  document.getElementById("fbbuild").textContent=document.getElementById("fbattach").checked?buildSnapshot():"";m.hidden=false;document.body.style.overflow="hidden";
  if(!MOB.matches)setTimeout(function(){document.getElementById("fbmsg").focus({preventScroll:true})},50)}
function fbClose(){document.getElementById("fbm").hidden=true;document.body.style.overflow=""}
document.getElementById("fbkopen").onclick=fbOpen;
document.getElementById("fbattach").onchange=function(){document.getElementById("fbbuild").textContent=this.checked?buildSnapshot():""};
document.getElementById("fbm").addEventListener("click",function(e){if(e.target.closest("[data-fbclose]"))fbClose()});
document.addEventListener("keydown",function(e){if(e.key==="Escape"&&!document.getElementById("fbm").hidden)fbClose()});
document.getElementById("fbsend").onclick=function(){
  var msg=document.getElementById("fbmsg");
  if(!msg.value.trim()){msg.focus();msg.placeholder="Tell us a little about it first";return}
  var payload={type:(document.querySelector("input[name=fbt]:checked")||{}).value,message:msg.value.trim(),email:document.getElementById("fbmail").value.trim(),build:document.getElementById("fbattach").checked?buildSnapshot():""};
  sendFeedback(payload);
  document.getElementById("fbform").hidden=true;document.getElementById("fbdone").hidden=false;msg.value=""};

seedSetLines();seedSetKits();paintColorStep();draw();

/* rails need at least one socket pack: block Add To Cart until one is picked */
function packsShort(){return mode==="sets"?(pick<0?0:Math.max(0,setKitAllow()-skits.length)):Math.max(0,railsInBuild()-kits.length)}function needPacks(){return packsShort()>0}
function gate(){var b=document.getElementById("ctab");if(!b)return;
  if(needPacks()){var n=packsShort();b.classList.add("need");b.innerHTML="Pick "+n+" more twist lock pack"+(n>1?"s":"")}else{b.classList.remove("need");if(!b.textContent.trim()||/^Pick /.test(b.textContent))b.textContent="Add To Cart"}}
function goPacks(){var n=packsShort();showErr("Each rail needs a pack of twist locks, and every rail comes with one free. Pick "+n+" more pack"+(n>1?"s":"")+".");
  var t=[].filter.call(document.querySelectorAll("#grx .meter,#grx .krs"),function(e){return e.offsetParent!==null})[0];
  if(t)t.scrollIntoView({behavior:"smooth",block:"center"})}
var _draw=draw;draw=function(){_draw.apply(this,arguments);gate();var e=document.getElementById("grerr");if(e&&/twist lock/.test(e.textContent)&&needPacks()){var n=packsShort();e.textContent="Each rail needs a pack of twist locks, and every rail comes with one free. Pick "+n+" more pack"+(n>1?"s":"")+"."}else if(e&&!(needPacks()&&/twist lock/.test(e.textContent)))e.textContent=""};
document.getElementById("ctab").onclick=addToCart;
gate();

document.querySelectorAll('.thumbs .th').forEach(function(w){w.onclick=function(){var t=w.querySelector('img');document.getElementById('mainimg').src=t.dataset.full||t.src;document.querySelectorAll('.thumbs .th').forEach(function(x){x.classList.remove('on')});w.classList.add('on');if(w.scrollIntoView&&MOB.matches)w.scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'})}});
function setQty(v){QTY=Math.max(1,v);var el=document.getElementById('qtyp');if(el)el.querySelector('b').textContent=QTY}
(function(){var el=document.getElementById('qtyp'),sp=el.querySelectorAll('span');
  sp[0].onclick=function(){setQty(QTY-1);draw()};sp[1].onclick=function(){setQty(QTY+1);draw()}})();


/* load the full-size photos in the background so switching thumbnails is instant */
(function(){var keep=[];function pre(){[].forEach.call(document.querySelectorAll('#grx .thumbs img[data-full]'),function(i){var im=new Image();im.decoding='async';im.src=i.dataset.full;keep.push(im)})}
if(document.readyState==='complete')setTimeout(pre,300);else window.addEventListener('load',function(){setTimeout(pre,300)})})();

/* ===== Thumbnail slider: drag with momentum, rubber-band ends, lands on whole thumbnails ===== */
(function(){
  var vp=document.querySelector('#grx .thumbs');if(!vp)return;
  var ths=[].slice.call(vp.querySelectorAll('.th'));if(!ths.length)return;
  var tr=document.createElement('div');tr.className='thtrack';ths.forEach(function(t){tr.appendChild(t)});vp.appendChild(tr);vp.classList.add('slide');
  /* minimal orange chevrons beside the row (outside the photos) */
  var wrap=document.createElement('div');wrap.className='thwrap';vp.parentNode.insertBefore(wrap,vp);wrap.appendChild(vp);
  var CHEV='<svg viewBox="0 0 8 14" width="8" height="14" aria-hidden="true"><path d="M6.5 1 1.5 7l5 6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var aL=document.createElement('button'),aR=document.createElement('button');
  aL.type=aR.type='button';aL.className='thnav l';aR.className='thnav r';aL.setAttribute('aria-label','Previous photos');aR.setAttribute('aria-label','More photos');
  aL.innerHTML=CHEV;aR.innerHTML=CHEV;wrap.appendChild(aL);wrap.appendChild(aR);
  var x=0,v=0,raf=0,target=null,minX=0,drag=null,moved=false,wheelT=0;
  function pad(){return parseFloat(getComputedStyle(vp).paddingRight)||0}
  function padL(){return parseFloat(getComputedStyle(vp).paddingLeft)||0}
  function cw(){return vp.clientWidth-padL()-pad()}
  function gap(){return parseFloat(getComputedStyle(tr).columnGap)||0}
  function stepPx(){return ths[0].getBoundingClientRect().width+gap()}
  function bounds(){minX=Math.min(0,cw()-tr.scrollWidth)}
  /* resting spots: every whole thumbnail, plus the very end */
  function snap(p){var sp=stepPx();if(p>=0)return 0;if(p<=minX)return minX;var s=Math.round(p/sp)*sp;if(s<minX)s=minX;if(Math.abs(p-minX)<Math.abs(p-s))s=minX;return s}
  function rubber(o,d){var c=0.55;return (1-1/(Math.abs(o)*c/d+1))*d*(o<0?-1:1)}
  function render(){tr.style.transform='translate3d('+x.toFixed(2)+'px,0,0)';var l=x<-1,r=x>minX+1;vp.classList.toggle('fl',l);vp.classList.toggle('fr',r);wrap.classList.toggle('fl',l);wrap.classList.toggle('fr',r)}
  function over(){return x>0?x:(x<minX?x-minX:0)}
  function step(now){
    var dt=Math.min(32,now-(step.t||now))||16;step.t=now;step.last=performance.now();
    if(target!=null){                       /* glide to a target: critically damped spring, keeps the flick's speed */
      var k=0.0007,c=2*Math.sqrt(k);v+=(-k*(x-target)-c*v)*dt;x+=v*dt;
      if(Math.abs(x-target)<0.3&&Math.abs(v)<0.01){x=target;v=0;target=null}
    }else{
      var o=over();
      if(o){var k2=0.0006,c2=2*Math.sqrt(k2)*0.78;v+=(-k2*o-c2*v)*dt;x+=v*dt;  /* springy bounce back */
        if(Math.abs(over())<0.3&&Math.abs(v)<0.02){x=x>0?0:minX;v=0}}
      else if(v){target=snap(x+v*240)}                                          /* coast, then settle on a whole thumbnail */
    }
    render();
    if(v||target!=null||over()){raf=requestAnimationFrame(step)}else{raf=0;step.t=0}
  }
  function kick(){if(!raf){step.t=0;step.last=performance.now();raf=requestAnimationFrame(step)}}
  function stop(){if(raf)cancelAnimationFrame(raf);raf=0;step.t=0;target=null}
  function goTo(t){stop();target=t;kick()}
  /* pointer drag (mouse + touch) */
  vp.addEventListener('pointerdown',function(e){if(e.button>0)return;stop();bounds();
    drag={id:e.pointerId,sx:e.clientX,sy:e.clientY,x0:x,lx:e.clientX,lt:performance.now(),dir:0};moved=false;v=0});
  vp.addEventListener('pointermove',function(e){if(!drag||e.pointerId!==drag.id)return;
    var dx=e.clientX-drag.sx,dy=e.clientY-drag.sy;
    if(!drag.dir){if(Math.abs(dx)<5&&Math.abs(dy)<5)return;drag.dir=Math.abs(dx)>Math.abs(dy)?'x':'y';if(drag.dir==='x'){try{vp.setPointerCapture(e.pointerId)}catch(_){}vp.classList.add('dragging')}}
    if(drag.dir!=='x')return;
    moved=true;e.preventDefault();
    var raw=drag.x0+dx,w=vp.clientWidth;x=raw>0?rubber(raw,w):(raw<minX?minX+rubber(raw-minX,w):raw);
    var now=performance.now(),dtm=now-drag.lt;if(dtm>0){var inst=(e.clientX-drag.lx)/dtm;v=0.8*inst+0.2*v}drag.lx=e.clientX;drag.lt=now;render()});
  function end(e){if(!drag||(e&&e.pointerId!==drag.id))return;var was=drag.dir==='x',lt=drag.lt;drag=null;vp.classList.remove('dragging');
    if(was){if(performance.now()-lt>80)v=0;v=Math.max(-4,Math.min(4,v));
      if(over()){kick()}else{target=snap(x+v*240);kick()}
      setTimeout(function(){moved=false},80)}}
  vp.addEventListener('pointerup',end);vp.addEventListener('pointercancel',end);vp.addEventListener('lostpointercapture',end);
  window.addEventListener('pointerup',function(){if(drag)end({pointerId:drag.id})},true);
  window.addEventListener('pointercancel',function(){if(drag)end({pointerId:drag.id})},true);
  window.addEventListener('blur',function(){if(drag)end({pointerId:drag.id})});
  document.addEventListener('visibilitychange',function(){if(!document.hidden){bounds();if(over()||x!==snap(x))goTo(snap(x))}});
  /* safety net: never leave the row parked past an end or between thumbnails */
  setInterval(function(){if(drag)return;if(raf&&performance.now()-(step.last||0)>600){cancelAnimationFrame(raf);raf=0}
    if(!raf){bounds();if(over()||target!=null)kick();else if(Math.abs(x-snap(x))>0.5)goTo(snap(x))}},400);
  vp.addEventListener('click',function(e){if(moved){e.stopPropagation();e.preventDefault();moved=false}},true);
  vp.addEventListener('dragstart',function(e){e.preventDefault()});
  /* trackpad / wheel: horizontal swipes, or shift + wheel; settles on a whole thumbnail */
  vp.addEventListener('wheel',function(e){var d=Math.abs(e.deltaX)>Math.abs(e.deltaY)?e.deltaX:(e.shiftKey?e.deltaY:0);if(!d)return;
    e.preventDefault();stop();bounds();var raw=x-d;var o=raw>0?raw:(raw<minX?raw-minX:0);
    x=o?(raw>0?rubber(raw,vp.clientWidth*0.5):minX+rubber(raw-minX,vp.clientWidth*0.5)):raw;v=0;render();
    clearTimeout(wheelT);wheelT=setTimeout(function(){goTo(snap(x))},120)},{passive:false});
  /* click a thumbnail: swap the photo; keep it fully in view with a neighbor showing */
  function reveal(th){bounds();var sp=stepPx(),i=ths.indexOf(th),vis=Math.max(1,Math.floor((cw()+gap())/sp));
    var first=Math.round(-x/sp);var want=first;if(i>=first+vis-1)want=i-vis+2;else if(i<=first)want=i-1;
    goTo(snap(-Math.max(0,want)*sp))}
  ths.forEach(function(w){w.onclick=function(){var t=w.querySelector('img');document.getElementById('mainimg').src=t.dataset.full||t.src;
    ths.forEach(function(o){o.classList.remove('on')});w.classList.add('on');reveal(w)}});
  /* arrows page by a full set of thumbnails */
  function page(dir){bounds();var sp=stepPx(),n=Math.max(1,Math.floor((cw()+gap())/sp));var base=target!=null?target:snap(x);goTo(snap(base-dir*n*sp))}
  aL.addEventListener('click',function(){page(-1)});aR.addEventListener('click',function(){page(1)});
  window.addEventListener('resize',function(){bounds();x=snap(x);render()});
  bounds();render();
})();
})();
